import { useCallback, useEffect, useState } from 'react';
import { API_URL } from '../config';
import { useAuth } from '../contexts/AuthContext';

export const useActiveParlaysCount = () => {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchCount = useCallback(async () => {
    if (!user?.issuer) {
      setCount(0);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/user/parlays/active?user_issuer=${user.issuer}&status=active`, {
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.ok) {
        const data = await response.json();
        setCount(data.parlays?.length || 0);
      } else {
        setCount(0);
      }
    } catch (error) {
      console.error('Error fetching active parlays count:', error);
      setCount(0);
    } finally {
      setLoading(false);
    }
  }, [user?.issuer]);

  useEffect(() => {
    fetchCount();
  }, [fetchCount]);

  return { count, loading, refetch: fetchCount };
};